import { takeEvery, select, cancel, cancelled, call, delay, takeLatest, put } from 'redux-saga/effects';
import {
    API_START_HEARTBEATEN,
    API_STOP_HEARTBEATEN,
} from '../../constants/API';

import { runSessionTokenIsOver, stopHeartBeaten } from '../../store/API/actions';
import { chooseServiceGenerator } from './utils';
import service from '../../services';




function* ocularisLoopHeartBeaten() {
    while (true) {
        try {
            const { token } = yield select(state => state.API);

            if (token)
                yield call(service.checkConnection, token);
            yield delay(5000);
        } catch (e) {
            yield put(runSessionTokenIsOver());
            yield put(stopHeartBeaten());
        } finally {
            if (yield cancelled()) {
                yield put(runSessionTokenIsOver());
                yield put(stopHeartBeaten());
            }
        }
    }
}

function* cayugaLoopHeartBeaten() {
    while (true) {
        try {
            const { token } = yield select(state => state.API);

            if (token) {
                const res = yield call(service.checkConnection, token);
                if (res.error) {
                    yield put(runSessionTokenIsOver());
                    yield put(stopHeartBeaten());
                }
            }
            yield delay(5000);
        } catch (e) {
            yield put(runSessionTokenIsOver());
            yield put(stopHeartBeaten());
        }
    }
}

function* cancelAndReinit(oldTask) {
    yield cancel(oldTask);
    const newTask = yield takeEvery(API_START_HEARTBEATEN, chooseServiceGenerator, 
        {fn: ocularisLoopHeartBeaten, args: []}, 
        {fn: cayugaLoopHeartBeaten, args: []}
    );
    yield takeLatest(API_STOP_HEARTBEATEN, cancelAndReinit, newTask);
}

export default function* () {
    const task = yield takeEvery(API_START_HEARTBEATEN, chooseServiceGenerator, 
        {fn: ocularisLoopHeartBeaten, args: []}, 
        {fn: cayugaLoopHeartBeaten, args: []}
    );
    yield takeLatest(API_STOP_HEARTBEATEN, cancelAndReinit, task);
}